import React from "react";

const SelectAllIcon = ({ width = 15, height = 15, fill = "#686868", ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.39375 11.6063V3.39375H11.6063V11.6063H3.39375ZM4.71728 10.2827H10.2827V4.71728H4.71728V10.2827ZM1.42544 13.5746V15C1.03338 15 0.697794 14.8604 0.418676 14.5813C0.139559 14.3022 0 13.9666 0 13.5746H1.42544ZM0 11.6063V10.181H1.42544V11.6063H0ZM0 8.21272V6.78728H1.42544V8.21272H0ZM0 4.81897V3.39375H1.42544V4.81897H0ZM1.42544 1.42544H0C0 1.03338 0.139559 0.697794 0.418676 0.418676C0.697794 0.139558 1.03338 0 1.42544 0V1.42544ZM3.39375 15V13.5746H4.81897V15H3.39375ZM3.39375 1.42544V0H4.81897V1.42544H3.39375ZM6.78728 15V13.5746H8.21272V15H6.78728ZM6.78728 1.42544V0H8.21272V1.42544H6.78728ZM10.181 15V13.5746H11.6063V15H10.181ZM10.181 1.42544V0H11.6063V1.42544H10.181ZM13.5746 15V13.5746H15C15 13.9694 14.8604 14.3057 14.5813 14.5833C14.3022 14.8611 13.9666 15 13.5746 15ZM13.5746 11.6063V10.181H15V11.6063H13.5746ZM13.5746 8.21272V6.78728H15V8.21272H13.5746ZM13.5746 4.81897V3.39375H15V4.81897H13.5746ZM13.5746 1.42544V0C13.9666 0 14.3022 0.139558 14.5813 0.418676C14.8604 0.697794 15 1.03338 15 1.42544H13.5746Z"
        fill={fill}
      />
    </svg>
  );
};

export default SelectAllIcon;

